import Accessibility from "@FRAMEWORK/ui/mobile/text/Accessibility";
import styled, {css} from "@yb/styled-px2rem";
import GuideText from "@FRAMEWORK/ui/mobile/text/GuideText";

const BlueText = styled.span`
	color: #4567ad;
`;

const Ellipsis = (line: number) => `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box; 
    -webkit-line-clamp: ${line};
    -webkit-box-orient: vertical;
`;

const RedText = styled.span`
	color: var(--red-color);
`;

const Title = styled.h2`
	font-weight: bold;
	font-size: 21px;
	color: var(--emp-color);
	line-height: 1.4;
`;

const SubTitle = styled.h3`
	width: 100%;
	font-weight: bold;
	font-size: 18px;
	color: var(--emp-color);
`;

const EnglishTitle = styled.span`
	display: block;
	margin-top: 5px;
	font-size: 12px;
	color: var(--default-color);
`;

const InputLabel = styled.label<{isRequired?: boolean}>`
	position: relative;
	${props =>
		props.isRequired &&
		css`
			&:before {
				position: absolute;
				left: -7px;
				content: "*";
				color: var(--red-color);
			}
		`}
`;
const EditorText = styled.p`
	font-size: 15px;
	color: var(--default-color);
	line-height: 1.6;
	word-break: break-word;
`;

export {BlueText, Ellipsis, RedText, Title, EnglishTitle, InputLabel, EditorText, GuideText, SubTitle, Accessibility};
